import { useDynamicEnums, useRemoteSearch } from '@spx-portal/shared-hooks';
import { StationListItem } from '@spx-portal/shared-hooks/dts/shared-hooks/src/useStation';
import { checkHasPermission } from '@spx-portal/shared-utils';
import * as React from 'react';

import { $gt, VueCtxStore } from '@/common/appCtx';

import { getStationDropdownList } from '../api';

export const SELECT_DEFAULT_DROPDOWN_COUNT = 50;

export const useStationList = () => {
  const stationTypeEnum = useDynamicEnums({ path:'station_types' }).enums || {};
  const loadStationDropdownListAction = async(params: { station_name: string; count: number }) => {
    const station_type_list = `${stationTypeEnum['First Mile HUB']},${stationTypeEnum.DC},${stationTypeEnum.HUB},${stationTypeEnum['All Mile HUB']},${stationTypeEnum['VIP PUP']},${stationTypeEnum['FBS Warehouse']},${stationTypeEnum['Operator Hub']},${stationTypeEnum['Mobile Hub']}`;
    const finalParams = {
      station_type_list,
      ...params,
    };
    return await getStationDropdownList(finalParams);
  };

  const setStationList = React.useCallback((list: StationListItem[]) => {
    const hasPermission = checkHasPermission(VueCtxStore, 'WORKFORCE_ROSTER_PLANNING_SLOT_CREATE_STATION_ALL');
    const allStationItem = hasPermission ? [{
      label: $gt('All Stations'),
      value: 0,
    }] : [];
    return [
      ...allStationItem,
      ...list.map((row) => ({
        label: `[${row.id}] ${row.station_name}`,
        value: row.id,
      })),
    ];
  }, []);

  const { loading, options, handleDebounceQuerySearch, handleDropdownVisibleChange } =
    useRemoteSearch({
      searchFn: loadStationDropdownListAction,
      transformer: setStationList,
      listKey: 'data.station_list',
      queryKey: 'station_name',
      dropdownLoading: true,
    });

  const onStationDropdownVisibleChangeRef = React.useRef(handleDropdownVisibleChange);

  return {
    loading,
    options,
    getStationList: handleDebounceQuerySearch,
    onStationDropdownVisibleChangeRef,
  };
};
